import { Country } from "react-phone-number-input";

export const phonesNumberCountries: Country[] = ["FR", "MC", "IT", "DK", "GB"]